import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

import { tr } from "../../i18n";
const BackButton = ({ url, params = null }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    if (!url) {
      if (pathSegments.length > 1) {
        pathSegments.pop(); // Hapus segmen terakhir
        navigate(`/${pathSegments.join("/")}`, { state: params }); // Gunakan state untuk mengirim params
      } else {
        navigate("/", { state: params });
      }
    } else {
      navigate(url);
    }
  };

  return (
    <Button variant="secondary" onClick={handleBack}>
      <FontAwesomeIcon icon={faArrowLeft} /> {" "}{tr("common:actions.back")}
    </Button>
  );
};

export default BackButton;
